export const Constants = {
	//Estados de los envíos de formularios
	NOT_SENT_STATUS: -1, // El formulario no se pudo enviar al destinatario
	SENT_STATUS: 0, // El formulario se ha enviado al destinatario
	STORED_STATUS: 1, // El destinatario ha guardado el formulario. Puede seguir contestando al formulario
	SUBMITTED_STATUS: 2, // El destinatario ha enviado el formulario. No puede seguir contestando al formulario
	REVIEW_PENDING_STATUS: 3, // El administrador ha visto el envío finalizado y decide que hay que revisarlo
	REVIEWED_STATUS: 4, // El administrador ha revisado el envío. Se pueden hacer más revisiones
	FINISHED_STATUS: 5, // El administrador da por finalizada la revisión del envío
}